import React, {useState} from "react";
import axios from "axios";
import {NavLink} from "react-router-dom";
import * as config from "../../configs/Config";
import {adaptUser, persistAuth} from "../../libraries/Authentication";
import AuthShell, {AuthButton, AuthError, AuthInput, AuthLabel} from "./AuthShell";

export default function Register() {
    const [form, setForm] = useState({email: '', password: '', confirm: '', terms: false});
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const set = (key, val) => {
        setError(null);
        setForm({...form, [key]: val});
    };

    const submit = async () => {
        if (!form.email || !form.password) return setError('Please fill the form');
        if (form.password.length < 8) return setError('Password needs at least 8 characters');
        if (form.password !== form.confirm) return setError("Passwords don't match");
        if (!form.terms) return setError('Please accept the terms to continue');
        setBusy(true);
        try {
            const {data} = await axios.post(`${config.API_URL}/register`, {
                email: form.email,
                password: form.password,
            }, {headers: {Accept: 'application/json'}});
            const adapted = adaptUser(data.user);
            persistAuth(data.token, adapted);
            window.location.replace('/');
        } catch (err) {
            setError(err.response?.data?.errors?.email?.[0] || err.response?.data?.message || err.message);
            setBusy(false);
        }
    };

    return (
        <AuthShell>
            <h1 className="font-heading mt-5 text-center text-[26px] font-bold tracking-[-0.015em]">Start with one song</h1>
            <p className="mb-6 mt-1 text-center text-[13px] text-white/40">
                Free account. Your taste starts building on the first play.
            </p>

            <AuthLabel htmlFor="reg-email">Email</AuthLabel>
            <AuthInput id="reg-email" type="email" placeholder="you@email.com" onChange={e => set('email', e.target.value)}/>
            <AuthLabel htmlFor="reg-password">Password</AuthLabel>
            <AuthInput id="reg-password" type="password" placeholder="8+ characters" onChange={e => set('password', e.target.value)}/>
            <AuthLabel htmlFor="reg-confirm">Confirm password</AuthLabel>
            <AuthInput id="reg-confirm" type="password" onChange={e => set('confirm', e.target.value)}/>

            <label className="mt-4 flex items-start gap-2.5 text-[12.5px] text-white/50">
                <input type="checkbox" checked={form.terms} onChange={e => set('terms', e.target.checked)}
                       className="mt-0.5 accent-apple-red"/>
                I agree to the Terms &amp; Privacy Policy
            </label>
            <p className="mt-3 text-[11.5px] text-white/40">
                Full songs need an Apple Music subscription. Previews work without one.
            </p>

            <AuthButton onClick={submit} disabled={busy}>{busy ? 'Creating…' : 'Create account'}</AuthButton>
            <AuthError error={error}/>
            <p className="mt-5 text-center text-[13px] text-white/40">
                Already have one? <NavLink to="/login" className="font-bold text-white hover:text-apple-red">Log in</NavLink>
            </p>
        </AuthShell>
    );
}
